import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
// 原始的公用请求头配置
const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 自定义logo save
export const customerLogoSave = (data: any) =>
  request.post('/crm/customInfo/save', data, jsonHeaderConfig)

// 获取自定义logo
export const customerLogoGet = () =>
  request.post('/crm-report/customInfo/customInfo', null, jsonHeaderConfig)
// 全局获取info
export const globalInfoGet = (data: any) =>
  request.post('/crm/api/custom/customInfo', data, jsonHeaderConfig)

// 自定义品牌 save
export const customerBrandSave = (data: any) =>
  request.post('/admin/customBrand/saas/submitSave', data, jsonHeaderConfig)
// 获取自定义品牌
export const customerBrandGet = () =>
  request.post('/admin/customBrand/saas/findInfo', null, jsonHeaderConfig)
// 是否购买应用
export const getByNum = (data: any) =>
  request.post('/crm/customInfo/getByNum', data, jsonHeaderConfig)
